import numeral from "numeral";
import React, { Component } from "react";
import icon from "../assets/list-icon.svg";
import CheckBox from "./Toggle-button";
import API from "./Api";
import Select from "../common/Select";
import { connect } from "react-redux";
const mapStateToProps = (state) => ({
  headers: state.headers(),
});
export default connect(mapStateToProps)(
  class Service extends Component {
    state = {
      deletingService: false,
    };

    deleteService = (isActive) => {
      this.setState({ deletingService: true });
      API.put(
        `business/services/${this.props.data.identifier}`,
        { ...this.props.data, is_active: isActive },
        { headers: this.props.headers }
      )
        .then(({ data }) => {
          window.$.notify(
            data.data.is_active === 1
              ? "Service Activated"
              : "Service Deactivated ",
            "success-alert"
          );
          // Notify parent of the update
          if (this.props.onToggleActive) {
            this.props.onToggleActive(data.data);
          }
        })
        .finally(() => {
          this.setState({ deletingService: false });
        });
    };

    render() {
      return (
        <div className={`service new-service-card`} data-id={this.props.data.id}>
          <div className="drag-handle drag-group">
            <DragIcon />
          </div>
          <img className="drag-group" src={icon} alt="" />
          <div>
            <CheckBox
              data_open={+this.props.data.is_active === 1}
              OnChange={(isActive) => this.deleteService(isActive ? 1 : 0)}
            />
            <p className="title">{this.props.data.name}</p>
            <div className="service-footer">
              <p className="mini-grid">
                <span>{this.props.data.duration} mins</span>
                <span className="time">
                  ₦{numeral(this.props.data.price).format("0,0")}
                </span>
              </p>
            </div>

            <div>
              {!this.props.notEditable ? (
                <button
                  style={{ marginLeft: 30 }}
                  onClick={this.props.editOnclick}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                  >
                    <path
                      d="M0 15.2501V19.0001H3.75L14.81 7.94006L11.06 4.19006L0 15.2501ZM17.71 5.04006C18.1 4.65006 18.1 4.02006 17.71 3.63006L15.37 1.29006C14.98 0.900059 14.35 0.900059 13.96 1.29006L12.13 3.12006L15.88 6.87006L17.71 5.04006Z"
                      fill="#E40587"
                    />
                  </svg>
                </button>
              ) : (
                ""
              )}

              <button
                className="delete_icon"
                onClick={this.props.deleteOnclick}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="19"
                  viewBox="0 0 14 19"
                  fill="none"
                >
                  <path
                    d="M1 5V17.5C1 18.3284 1.67157 19 2.5 19H11.5C12.3284 19 13 18.3284 13 17.5V5H1Z"
                    fill="#E40587"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 1.5V1C9 0.447715 8.55228 0 8 0H6C5.44772 0 5 0.447715 5 1V1.5H0.5C0.223858 1.5 0 1.72386 0 2V2.5C0 2.77614 0.223858 3 0.5 3H13.5C13.7761 3 14 2.77614 14 2.5V2C14 1.72386 13.7761 1.5 13.5 1.5H9Z"
                    fill="#E40587"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
);

 const DragIcon = () => (
  <svg
    width="16"
    height="8"
    viewBox="0 0 16 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.799988 1.60039C0.799988 1.28213 0.926416 0.976906 1.15146 0.751863C1.3765 0.526819 1.68173 0.400391 1.99999 0.400391C2.31825 0.400391 2.62347 0.526819 2.84852 0.751863C3.07356 0.976906 3.19999 1.28213 3.19999 1.60039C3.19999 1.91865 3.07356 2.22388 2.84852 2.44892C2.62347 2.67396 2.31825 2.80039 1.99999 2.80039C1.68173 2.80039 1.3765 2.67396 1.15146 2.44892C0.926416 2.22388 0.799988 1.91865 0.799988 1.60039ZM6.79999 1.60039C6.79999 1.28213 6.92642 0.976906 7.15146 0.751863C7.3765 0.526819 7.68173 0.400391 7.99999 0.400391C8.31825 0.400391 8.62347 0.526819 8.84852 0.751863C9.07356 0.976906 9.19999 1.28213 9.19999 1.60039C9.19999 1.91865 9.07356 2.22388 8.84852 2.44892C8.62347 2.67396 8.31825 2.80039 7.99999 2.80039C7.68173 2.80039 7.3765 2.67396 7.15146 2.44892C6.92642 2.22388 6.79999 1.91865 6.79999 1.60039ZM12.8 1.60039C12.8 1.28213 12.9264 0.976906 13.1515 0.751863C13.3765 0.526819 13.6817 0.400391 14 0.400391C14.3182 0.400391 14.6235 0.526819 14.8485 0.751863C15.0736 0.976906 15.2 1.28213 15.2 1.60039C15.2 1.91865 15.0736 2.22388 14.8485 2.44892C14.6235 2.67396 14.3182 2.80039 14 2.80039C13.6817 2.80039 13.3765 2.67396 13.1515 2.44892C12.9264 2.22388 12.8 1.91865 12.8 1.60039ZM0.799988 6.40039C0.799988 6.08213 0.926416 5.77691 1.15146 5.55186C1.3765 5.32682 1.68173 5.20039 1.99999 5.20039C2.31825 5.20039 2.62347 5.32682 2.84852 5.55186C3.07356 5.77691 3.19999 6.08213 3.19999 6.40039C3.19999 6.71865 3.07356 7.02388 2.84852 7.24892C2.62347 7.47396 2.31825 7.60039 1.99999 7.60039C1.68173 7.60039 1.3765 7.47396 1.15146 7.24892C0.926416 7.02388 0.799988 6.71865 0.799988 6.40039ZM6.79999 6.40039C6.79999 6.08213 6.92642 5.77691 7.15146 5.55186C7.3765 5.32682 7.68173 5.20039 7.99999 5.20039C8.31825 5.20039 8.62347 5.32682 8.84852 5.55186C9.07356 5.77691 9.19999 6.08213 9.19999 6.40039C9.19999 6.71865 9.07356 7.02388 8.84852 7.24892C8.62347 7.47396 8.31825 7.60039 7.99999 7.60039C7.68173 7.60039 7.3765 7.47396 7.15146 7.24892C6.92642 7.02388 6.79999 6.71865 6.79999 6.40039ZM12.8 6.40039C12.8 6.08213 12.9264 5.77691 13.1515 5.55186C13.3765 5.32682 13.6817 5.20039 14 5.20039C14.3182 5.20039 14.6235 5.32682 14.8485 5.55186C15.0736 5.77691 15.2 6.08213 15.2 6.40039C15.2 6.71865 15.0736 7.02388 14.8485 7.24892C14.6235 7.47396 14.3182 7.60039 14 7.60039C13.6817 7.60039 13.3765 7.47396 13.1515 7.24892C12.9264 7.02388 12.8 6.71865 12.8 6.40039Z"
      fill="#737A91"
    />
  </svg>
)
